var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChrome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M23.12 7.5H12a4.5 4.5 0 0 0-3.929 6.7l-5.56-9.54c4.05-5.24 11.581-6.206 16.822-2.157a11.992 11.992 0 0 1 3.787 4.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M24 12c-.006 6.625-5.375 11.994-12 12a10.704 10.704 0 0 1-1.5-.1l5.4-9.65a4.51 4.51 0 0 0-1.65-6.15 4.458 4.458 0 0 0-2.24-.6h11.11A11.83 11.83 0 0 1 24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M15.9 14.25l-5.4 9.65h-.01C3.92 23.07-.733 17.07.097 10.499A11.993 11.993 0 0 1 2.51 4.66l5.56 9.54.03.05a4.5 4.5 0 0 0 7.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M15.9 14.25a4.5 4.5 0 0 1-7.8 0l-.03-.05A4.5 4.5 0 0 1 12 7.5h.01a4.458 4.458 0 0 1 2.24.6 4.51 4.51 0 0 1 1.65 6.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M15.9 14.25a4.5 4.5 0 0 1-7.8 0l-.03-.05A4.5 4.5 0 0 1 12 7.5h.01a4.458 4.458 0 0 1 2.24.6 4.51 4.51 0 0 1 1.65 6.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M11.983 17c-.872 0-1.728-.23-2.483-.666A5 5 0 0 1 12 7a5 5 0 0 1 4.334 7.5 5.028 5.028 0 0 1-4.35 2.5zm.026-9a3.989 3.989 0 0 0-3.479 2 4.003 4.003 0 1 0 5.472-1.463A4 4 0 0 0 12.01 8h-.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChrome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chrome.bd1939c18fbfcd4bd5ee0a2805347179.svg";